import { SEND_FOLLOWUP_MESSAGE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface TagAppointmentResponse {
    success: boolean;
    error?: string;
}

export default async function sendFollowupReminders({
    aid,
}: {
    aid: string;
}): Promise<TagAppointmentResponse> {
    const response = await fetchWithRefresh(SEND_FOLLOWUP_MESSAGE(aid), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: 'include',
    });

    const res = await response.json();
    return res;
}
